export const AUTH_TIME_KEY = "last_reauth_time";
export const TIMEOUT_KEY = "session_timeout_seconds";

export function setSessionTimeout(timeout) {
	const numericTimeout = Number(timeout);
	if (!isNaN(numericTimeout) && numericTimeout > 0) {
		sessionStorage.setItem(TIMEOUT_KEY, numericTimeout.toString());
	}
}

export function updateLastAuthTime() {
	sessionStorage.setItem(AUTH_TIME_KEY, Date.now().toString());
}

export function getSessionTimeout() {
	return Number(sessionStorage.getItem(TIMEOUT_KEY)) || 43200;
}

export function getLastAuthTime() {
	return Number(sessionStorage.getItem(AUTH_TIME_KEY));
}
